/**
 * Stage 18 preview and apply. The browser identifies the preview it
 * showed. It does not send a workout, date, or duration.
 */
import { http } from "@/lib/api";

export const fetchAdaptationPreview = async (asOf, { signal } = {}) => {
  const { data } = await http.get("/training-block/current/adaptation-preview", {
    params: { as_of: asOf },
    signal,
  });
  return data;
};

export const applyAdaptationPreview = async ({ asOf, previewFingerprint }) => {
  const { data } = await http.post("/training-block/current/adaptation-apply", {
    as_of: asOf,
    preview_fingerprint: previewFingerprint,
  });
  return data;
};
